import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useNotify, useRefresh, ReferenceArrayInput, SelectArrayInput } from "react-admin";
import {TextInput, NumberInput, SimpleForm, ReferenceInput, SelectInput } from "react-admin";
import {Button, Container, Typography} from "@mui/material";
import {ENTRYPOINT} from "../../config/entrypoint";
import { getSelectedCompanyFilter } from '../../helper/filter';

const CourseGenerate = () => {
    const [count, setCount] = useState(10);
    const [countDates, setCountDates] = useState(10);
    const [prefix, setPrefix] = useState("A");
    const [cities, setCities] = useState([]);

    const notify = useNotify();
    const refresh = useRefresh();
    const navigate = useNavigate();
    const companyFilter = getSelectedCompanyFilter();
    const [loading, setLoading] = useState(false);

    const sendRequest = () => {
        setLoading(true);
        fetch(`${ENTRYPOINT}/courses/generate`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem('auth')}`,
            },
            body: JSON.stringify({
                count,
                prefix,
                companyFilter,
                countDates,
                cities: cities.map(id => parseInt(id.replace('/cities/', '')))
            })
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                if (data.success) {
                    notify(data.message, {type: "success"});
                } else {
                    notify(`Error: ${data.message}`, {type: 'error'});
                }
            })
            .catch((error) => {
                notify(`Error: ${error.message}`, {type: 'error'});
            })
            .finally(() => {
                setLoading(false);
                refresh();
                navigate('/courses?order=DESC&page=1&perPage=10&sort=createdAt');
            });
    };

    return (
        <Container>
            <Typography variant="h5" gutterBottom>Generate Courses</Typography>
            <SimpleForm sanitizeEmptyValues={true} onSubmit={sendRequest} toolbar={false}>
                <ReferenceInput
                    source="company"
                    reference="companies"
                    label="Company"
                >
                    <SelectInput
                        id="company"
                        fullWidth
                        source="company"
                        optionText="name"
                        disabled={true}
                        defaultValue={companyFilter.company}
                    />
                </ReferenceInput>
                <TextInput
                    label="Prefix"
                    source="prefix"
                    fullWidth
                    value={prefix}
                    onChange={(e) => setPrefix(e.target.value)}
                />
                <NumberInput
                    label="Amount of Courses"
                    source="count"
                    fullWidth
                    value={count}
                    onChange={(e) => setCount(Number(e.target.value))}
                />
                <ReferenceArrayInput
                    source={'cities'}
                    reference={'cities'}
                    name={'Cities'}
                >
                    <SelectArrayInput
                        source={'cities'}
                        reference={'cities'}
                        optionText={'view'}
                        onChange={(event) => {
                            const selectedCityIDs = event.target.value;
                            setCities(selectedCityIDs);
                        }}
                    />
                </ReferenceArrayInput>
                <NumberInput
                    label="Amount of dates per course city"
                    source="countDates"
                    fullWidth
                    value={countDates}
                    onChange={(e) => setCountDates(Number(e.target.value))}
                />
                <Button variant="contained" color="primary" onClick={sendRequest} sx={{mt: 2}}>
                    Generate
                </Button>
            </SimpleForm>
        </Container>
    );
};

export default CourseGenerate;
